module.exports = __webpack_public_path__ + "static/media/TJ-ControlPanel.f91e6a17.png";